import  { buttonFonts } from "@DSG/MobiusOverrides/styles/variables";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { Clickable } from "@insite/mobius/index";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser"
import * as React from "react";
import { css } from "styled-components";


type Props = OwnProps;

const enum fields {
    backToTopLabel = "backToTopLabel",
}

interface OwnProps extends WidgetProps  {
    fields: {
        [fields.backToTopLabel]: string;
    };
}

export interface BackToTopStyles {
    backToTopLinkWrapper?: InjectableCss;
    backToTopLink?: InjectableCss;
}


export const backToTopStyles: BackToTopStyles = {
    backToTopLinkWrapper: {
        css: css`
            padding: 8px;
            justify-content: center;
            display: flex;
        `
    },
    backToTopLink: {
        css: css`
            font: ${buttonFonts.buttonSm.fontWeight} ${buttonFonts.buttonSm.fontSize}/${buttonFonts.buttonSm.lineHeight} ${buttonFonts.buttonSm.fontFamily};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: ${buttonFonts.buttonLg.fontSize};
                            line-height: ${buttonFonts.buttonLg.lineHeight};
                        `,
                    ],
                    "max",
                )}
        `
    }
}

const styles = backToTopStyles;

const BackToTop = ({ fields }: Props) => {
    const scrollToTop = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault(); 
        window.scrollTo({
          top: 0,
          behavior: "smooth", 
        });
    };
    return (
        <StyledWrapper {...styles.backToTopLinkWrapper}>
            <Clickable onClick={scrollToTop} className="text-link-primary text-link-active" {...styles.backToTopLink}>
                {parse(fields.backToTopLabel, parserOptions)}
            </Clickable>
        </StyledWrapper>
    );
};


const widgetModule: WidgetModule = {
    component: BackToTop,
    definition: {
        group: "Common",
        displayName: "Back To Top",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.backToTopLabel,
                editorTemplate: "TextField",
                displayName: "Back To Top Label",
                defaultValue: "Back to top"
            }
        ],
    }
};

export default widgetModule;
